export default {
  title: {
    id: 'profile_page_legal_details_tab_title',
    defaultMessage: 'Legal details',
  },
  toDoLabel: {
    id: 'profile_page_legal_details_tab_do_do_label',
    defaultMessage: 'To do',
  },
  editButton: {
    id: 'profile_page_legal_details_tab_edit_button_label',
    defaultMessage: 'Edit',
  },
  emptyLegalDetail: {
    id: 'profile_page_legal_details_tab_empty_legal_detail',
    defaultMessage: 'Add this information now',
  },
  legalBusinessNameTitle: {
    id: 'profile_page_legal_details_tab_edit_legal_details_name_title',
    defaultMessage: 'Legal business name',
  },
  addDetailsButton: {
    id: 'profile_page_legal_details_tab_add_legal_details_button_label',
    defaultMessage: 'Add details',
  },
  legalDetailsDescription: {
    id: 'profile_page_legal_details_tab_add_legal_details_description',
    defaultMessage: 'Here’s what you need to add:',
  },
  vatNumberTitle: {
    id: 'profile_page_legal_details_tab_edit_vat_number_title',
    defaultMessage: 'Intra-community VAT or TIN/EIN',
  },
  companyIdentificationNumberTitle: {
    id: 'profile_page_legal_details_tab_edit_company_identification_number_title',
    defaultMessage: 'Company identification number',
  },
}
